import {
    tw as login_pageText
} from './pageText/login_pageText'
import {
    tw as home_pageText
} from './pageText/home_pageText'
import {
    tw as menu_pageText
} from './pageText/menu_pageText'
import {
    tw as common_pageText
} from './pageText/common_pageText'
import {
    tw as prompt_pageText
} from './pageText/prompt_pageText'
import {
    tw as tips_pageText
} from './pageText/tips_pageText'
import {
    tw as warning_pageText
} from './pageText/warning_pageText'
import {
    tw as tenderInfo_pageText
} from './pageText/tenderInfo_pageText'
import {
    tw as biddingList_pageText
} from './pageText/biddingList_pageText'
import {
    tw as changePassword_pageText
  } from './pageText/changePassword_pageText'
  import {
    tw as forget_pageText
  } from './pageText/forget_pageText'
import twLocale from 'element-ui/lib/locale/lang/zh-TW'
export default {
    login_pageText: {
        ...login_pageText
    },
    home_pageText: {
        ...home_pageText
    },
    menu_pageText: {
        ...menu_pageText
    },
    common_pageText: {
        ...common_pageText
    },
    prompt_pageText: {
        ...prompt_pageText
    },
    tips_pageText: {
        ...tips_pageText
    },
    warning_pageText: {
        ...warning_pageText
    },
    biddingList_pageText: {
        ...biddingList_pageText
    },
    tenderInfo_pageText: {
        ...tenderInfo_pageText
    },
    changePassword_pageText: {
        ...changePassword_pageText
    },
    forget_pageText: {
        ...forget_pageText
      },
    ...twLocale
}